<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners"></div>

     <div class="c-container">
         <div class="dh-content">
          <h1>家长监护工程</h1>
          <p>"网络游戏未成年人家长监护工程"是一项由中华人民共和国文化部指导，网络游戏企业共同发起并参与实施，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。"工程"提供了一种切实可行的方法，一种家长实 施监控的渠道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。</p>
          <p><span>未成年人健康参与网络游戏提示：</span></p>
          <p>随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。</p>
          <p>为此，我们为未成年人参与网络游戏提供以下意见：</p>
          <p>1. 主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</p>
          <p>2. 不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</p>
          <p>3. 不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</p>
          <p>4. 养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</p>
          <p>5. 注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</p>
          <p class="title-1">申请条件</p>
          <p>1. 申请人需为法定或指定的未成年人的监护人；</p>
          <p>2. 被监护人的年龄应小于18周岁。</p>
          <p>3. 申请人应为中国大陆公民，不含港、澳、台人士。</p>
          <p class="title-1">提交资料</p>
          <p>1. 网络游戏未成年人用户家长监控服务申请书、授权书并手工签字；<a style="color:red;" target="_blank" href="/word_download/ProtocolTemplate.doc">点击下载</a></p>
          <p>2. 监护人信息表；<a style="color:red;" target="_blank" href="/word_download/ProtocolTemplate.doc">点击下载</a></p>
          <p>3. 被监护人信息表；<a style="color:red;" target="_blank" href="/word_download/ProtocolTemplate.doc">点击下载</a></p>
          <p>4. 申请人与被监护人的监护关系证明文件</p>
          <p>5. 被监护人账户归属权证明文件</p>
          <p class="title-1">申请限制措施</p>
          <p>1. 根据监护人意愿屏蔽被监护未成年人相关游戏登录</p>
          <p>2. 根据监护人意愿，在被监护未成年人登录指定游戏时，邮件通知监护人。</p>
        </div>
     </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}

a, a:active, a:visited, a:hover, a:target {
    display: inline-block;
}

.banners{
  height: 130px;
  background: url(../../assets/images/agreement-bg.jpg) no-repeat center;
  background-size: cover;
}

.c-container{
	width: 100%;
}

.dh-content{
	position: relative;
	max-width: 512px;
	top: -40px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 25px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);
}
.ag-content{
	position: relative;
	width: 100%;
	top: 10px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 80px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);	
}
.dh-content h1,.ag-content h1{
	text-align: center;
	font-size: 13px;
	color: #333;
	margin-bottom: 10px;
}
.dh-content p,.ag-content p{
	line-height: 18px;
  font-size: 8px;
}
.dh-content p span,.ag-content p span{
	color: #000;
	font-weight: bold;
}
.dh-content p.title,.ag-content p.title{
	color: #000;
	font-weight: bold;
}
.dh-content p.title-1,.ag-content p.title-1{
	color: #000;
	font-weight: bold;
}


@media (max-width:800px) {
  .dh-content{
    top: 0;
    
  }
}

</style>
